export default __webpack_public_path__ + "static/media/56.b92eb990.png";